import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Landing from './pages/Landing';
import About from './pages/About';
import Work from './pages/Work';
import ProjectPage from './pages/ProjectPage';
import { projects } from './data/projects';
import { Analytics } from "@vercel/analytics/react"
import { AppProvider, useApp } from './context/AppContext';
import MitModal from './components/MitModal';
import './App.css';

// Component to handle MIT route detection
const MitRouteHandler = () => {
  const { setMitMode, setHideMitModal } = useApp();
  const navigate = useNavigate();
  console.log("MIT route detected");
  useEffect(() => {
    setMitMode(true);
    setHideMitModal(false);
    navigate('/', { replace: true });
  }, [setMitMode, setHideMitModal, navigate]);

  return null;
};

function AppContent() {
  const { mitMode, hideMitModal } = useApp();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (mitMode && !hideMitModal) {
      setIsModalOpen(true);
    }
  }, [mitMode, hideMitModal]);

  return (
    <div className="App">
      <Analytics/>
      {/* <MitModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} /> */}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/mit" element={<MitRouteHandler />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Work />} />
        <Route path="/projects/:projectId" element={<ProjectPage projects={projects} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <AppProvider>
      <Router>
        <AppContent />
      </Router>
    </AppProvider>
  );
}

export default App;
